<template>
  <div>

    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="3" >
        <CardSkeletonList v-if="loading_legajo" :count="1" />
        <CardInfo v-else :legajo="legajo" ref="CardInfo" />
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="9">
        <CardSkeletonList v-if="loading_legajo" :count="3" />
        <template v-else>
          <CardPersonalData :legajo="legajo" ref="CardPersonalData" :service="service"/>
          <CardPersonalWork :legajo="legajo" ref="CardPersonalWork" />
          <CardContact :legajo="legajo" ref="CardContact" />
          <CardAccess v-if="legajo.id > 0" :legajo="legajo" />
        </template>

      </v-col>
    </v-row>

    <v-row v-if="!loading_legajo">
      <v-col cols="12" md="12" class="d-flex justify-end">
        <v-btn color="primary" type="submit" :loading="loading" @click="createItem">{{legajo.id > 0 ? "Editar" : "Guardar"}}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CardInfo from "./LegajoInfo/CardInfo.vue";
import CardPersonalData from "./LegajoInfo/CardPersonalData.vue";
import CardPersonalWork from "./LegajoInfo/CardPersonalWork.vue";
import CardContact from "./LegajoInfo/CardContact.vue";
import CardAccess from "./LegajoInfo/CardAccess.vue";
import CardSkeletonList from "../../components/CardSkeletonList.vue";

export default {
  components: { CardInfo, CardPersonalData, CardPersonalWork, CardContact, CardAccess, CardSkeletonList },
  name: "LegajoInfo",
  props: {
    service: {
      type: Object
    },
    legajo: {
      type: Object
    },
    loading_legajo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    // Resultado del alta automatica del acceso del empleado (si el legajo tenia email y no tenia acceso)
    toastAccess(response) {
      if (!response.access_msg) return;
      if (response.access_status) this.$toast.success(response.access_msg, "Acceso");
      else this.$toast.warning(response.access_msg, "Acceso");
    },

    async createItem() {
      this.loading = true;
      const contactValid = await this.$refs.CardContact.validate();
      const personalDataValid = await this.$refs.CardPersonalData.validate();
      const personalWorkValid = await this.$refs.CardPersonalWork.validate();

      if (contactValid && personalDataValid && personalWorkValid) {
        if (this.legajo.id > 0) {

          this.service
            .update(this.legajo)
            .then((response) => {
              if (response.status == true) {
                this.$toast.success("El legajo se modifico correctamente.", "OK");
                this.toastAccess(response);
                this.$router.push("/legajos");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              this.$toast.error(response.msg, "Error");
            })
            .finally(() => (this.loading = false));
        } else {
          this.service
            .create(this.legajo)
            .then((response) => {
              if (response.status == true) {
                this.$toast.success("El legajo se creo correctamente", "OK");
                this.toastAccess(response);
                this.$router.push("/legajos");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.$toast.error(response.message, "Error");
                } else {
                  this.$toast.error(response.msg, "Error");
                }
              }
            })
            .catch((response) => {
              console.log(response);
              this.$toast.error(response.msg, "Error");
            })
            .finally(() => (this.loading = false));
        }
      } else {
        // Los errores se muestran debajo de cada campo
        this.loading = false;
      }
    }
  },
};
</script>
